
    import axios, { AxiosResponse } from 'axios';

    import { defineComponent } from 'vue';

     class EventPage {
        public pageSize: number = 0;
        public pageIndex: number = 0;
    }

    export default defineComponent({
        data() {
            return {
                lastpage: 0,
                pageindex: 0,
                pagesize:0,
            }
        },
        props: {
            totalcount: Number,
            pagesizeprop:Number,
            pagesizeoptions: Array,
            alignend: Boolean,
            page: String,
            pageindexprop: Number
        },
        mounted() {
            console.log("index " + this.pageindex);
            if (this.pageindexprop != null)
                this.pageindex = this.pageindexprop;
            if (this.pagesizeprop!=null)
            this.pagesize = this.pagesizeprop;
            if (this.totalcount != null && this.pagesize != null)
                this.lastpage = Math.ceil((this.totalcount - 1) / this.pagesize);
        },
        beforeUpdate() {
            if (this.pagesizeprop != null)
                this.pagesize = this.pagesizeprop;
            if (this.totalcount != null && this.pagesize != null)
                this.lastpage = Math.ceil((this.totalcount - 1) / this.pagesize);
        },
        watch: {
            totalcount: function (value) {
                if (this.pagesize!=null)
                this.lastpage = Math.ceil((value - 1) / this.pagesize);
            }
        },
        methods: {
            ChangePage(e: any, pageindex: number) {
                e.preventDefault();
                let event: EventPage = new EventPage();
                this.pageindex = pageindex;
                event.pageIndex = this.pageindex;
                event.pageSize = this.pagesize;
                this.$emit("changepageparent", event);
                return false;
            },

            ChangeIdlePage(e: any) {
                e.preventDefault();
            },

            UpdatePageSize(e: any) {
                this.pageindex = 1;
                this.pagesize = e.target.value;
                if (this.totalcount != null && (this.pagesize != null))
                    this.lastpage = Math.ceil((this.totalcount - 1) / this.pagesize);
                this.ChangePage(e, this.pageindex);
            }
        },
    });
